// src/pages/Home.js
import React from "react";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import CoursesSection from "../components/CoursesSection";
import WhyChooseUs from "../components/WhyChooseUs";
import MembershipSection from "../components/MembershipSection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import CTASection from "../components/CTASection";
import WhatsAppFloat from "../components/WhatsAppFloat";

function Home() {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <CoursesSection />
      <WhyChooseUs />
      <MembershipSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <WhatsAppFloat />
    </div>
  );
}

export default Home;
